/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MyStreakEntry } from './MyStreakEntry';
import {
    MyStreakEntryFromJSON,
    MyStreakEntryFromJSONTyped,
    MyStreakEntryToJSON,
    MyStreakEntryToJSONTyped,
} from './MyStreakEntry';

/**
 * 
 * @export
 * @interface MyStreaksResponse
 */
export interface MyStreaksResponse {
    /**
     * 
     * @type {Array<MyStreakEntry>}
     * @memberof MyStreaksResponse
     */
    streaks?: Array<MyStreakEntry>;
}

/**
 * Check if a given object implements the MyStreaksResponse interface.
 */
export function instanceOfMyStreaksResponse(value: object): value is MyStreaksResponse {
    return true;
}

export function MyStreaksResponseFromJSON(json: any): MyStreaksResponse {
    return MyStreaksResponseFromJSONTyped(json, false);
}

export function MyStreaksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyStreaksResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'streaks': json['streaks'] == null ? undefined : ((json['streaks'] as Array<any>).map(MyStreakEntryFromJSON)),
    };
}

export function MyStreaksResponseToJSON(json: any): MyStreaksResponse {
    return MyStreaksResponseToJSONTyped(json, false);
}

export function MyStreaksResponseToJSONTyped(value?: MyStreaksResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'streaks': value['streaks'] == null ? undefined : ((value['streaks'] as Array<any>).map(MyStreakEntryToJSON)),
    };
}

